export enum QueueStatus {
  Queued = 'queued',
  Retry = 'retry',
  InProgress = 'inProgress',
  Done = 'done',
  Failed = 'failed',
}
